$(() => {
    const fieldArray = $(allowPrompt).find('input, textarea');
    let allowPrompt = $('.js-allow-prompt');
    let leaveThePage = false;

    if (!allowPrompt.length) return;

    $(document).on('click', '.js-leave-page', () => {
        leaveThePage = true;
    });

    function areYouSure() {
        const newFieldArray = $(allowPrompt).find('input');
        const confMessage = "Are you sure you want to leave this page without saving changes?";
        let areYouReallySure = false;

        for (let i = 0; i < fieldArray.length; i++) {
            areYouReallySure = areYouReallySure
                || $(fieldArray[i]).val() === $(newFieldArray[i]).val();
        }

        if (!areYouReallySure || leaveThePage) return;

        return confMessage;
    }

    window.onbeforeunload = areYouSure;
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/close-confirmation.js